import React from 'react';

export interface AnswerOptionState {
  selected: boolean;
  correct: boolean;
  wrong: boolean;
  disabled: boolean;
}

interface AnswerButtonsProps {
  answers: [string, string, string, string];
  optionStates: [AnswerOptionState, AnswerOptionState, AnswerOptionState, AnswerOptionState];
  onSelectOption: (value: string) => void;
}

const AnswerButtonsComponent: React.FC<AnswerButtonsProps> = ({
  answers,
  optionStates,
  onSelectOption,
}) => {
  const buttonLabels = ['A', 'B', 'C', 'D'];
  const buttonIds = ['btnA', 'btnB', 'btnC', 'btnD'];

  const renderButton = (i: number) => {
    const state = optionStates[i];
    const className = [
      'option-btn',
      state.selected && 'option-selected',
      state.correct && 'correct',
      state.wrong && 'wrong',
      state.disabled && 'fifty-fifty-disabled',
    ].filter(Boolean).join(' ');

    return (
      <button
        id={buttonIds[i]}
        onClick={() => onSelectOption(answers[i])}
        type="button"
        disabled={state.disabled}
        className={className}
        data-answer={answers[i]}
      >
        <span className="me-2">{buttonLabels[i]}:</span> {answers[i]}
        {(state.correct || state.wrong) && (
          <>
            <span className="answer-status-icon" aria-hidden="true">
              {state.correct ? '✓' : '✗'}
            </span>
            <span className="answer-status-text">
              {state.correct ? 'Correcta' : 'Incorrecta'}
            </span>
          </>
        )}
      </button>
    );
  };

  return (
    <div id="buttons-container" className="w-100">
      <div className="row g-3">
        {[0, 1].map(i => (
          <div key={i} className="col-6">
            {renderButton(i)}
          </div>
        ))}
      </div>
      <div className="row g-3 mt-1">
        {[2, 3].map(i => (
          <div key={i} className="col-6">
            {renderButton(i)}
          </div>
        ))}
      </div>
    </div>
  );
};

export const AnswerButtons = React.memo(AnswerButtonsComponent);
